import React, { useEffect } from 'react';

interface CalApi {
  q: any[];
  loaded?: boolean;
  ns: Record<string, any>;
}

interface CalFunction extends Function {
  q: any[];
}

declare global {
  interface Window {
    Cal?: CalApi & ((...args: any[]) => void);
  }
}

const CalendarButton: React.FC = () => {
  useEffect(() => {
    // Initialize Cal.com
    (function (C: Window, A: string, L: string) {
      let p = function (a: CalFunction | CalApi, ar: any) {
        a.q.push(ar);
      };
      let d = C.document;
      C.Cal =
        C.Cal ||
        function (this: any, ...args: any[]) {
          let cal = C.Cal as CalApi;
          let ar = args;
          if (!cal.loaded) {
            cal.ns = {};
            cal.q = cal.q || [];
            d.head.appendChild(d.createElement('script')).src = A;
            cal.loaded = true;
          }
          if (ar[0] === L) {
            const api: CalFunction = Object.assign(function (this: any) {
              p(api, arguments);
            }, { q: [] });
            
            const namespace = ar[1];
            if (typeof namespace === 'string') {
              cal.ns[namespace] = cal.ns[namespace] || api;
              p(cal.ns[namespace], ar);
              p(cal, ['initNamespace', namespace]);
            } else p(cal, ar);
            return;
          }
          p(cal, ar);
        } as any;
    })(window, 'https://app.cal.com/embed/embed.js', 'init');

    // Initialize Cal
    if (window.Cal) {
      window.Cal('init', '20-min', { origin: 'https://cal.com' });

      window.Cal.ns['20-min']('floatingButton', {
        calLink: 'sparkskool/20-min',
        config: {
          layout: 'month_view',
          theme: 'light'
        },
        buttonColor: '#f1f1f1',
        buttonTextColor: '#000000'
      });

      window.Cal.ns['20-min']('ui', {
        theme: 'light',
        hideEventTypeDetails: false,
        layout: 'month_view'
      });
    }
  }, []); // Empty dependency array means this runs once on mount

  return null; // This component doesn't render anything visible
};

export default CalendarButton; 